import { Component, OnInit, HostListener, ViewEncapsulation, AfterViewInit, TemplateRef } from '@angular/core';
import { MenuService } from '../menu/menu.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HelpService } from '../../../_services/help.service';

@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.scss'],
  animations: [
    trigger('toggleHeight', [
      state('close', style({
        height: '0',
        overflow: 'hidden',
        marginBottom: '0',
        display: 'none',

      })),
      state('open', style({
        display: 'block',
        height: '*',
        marginBottom: '10px',
        overflow: 'hidden',
      })),
      transition('close => open', animate('140ms ease-in')),
      transition('open => close', animate('140ms ease-out'))
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class SearchPageComponent implements OnInit, AfterViewInit {
  loading = false ;
  menuItems: any;
  menuItemsOptional: any;

  currentItem = null;
  isPerfectScrollbarDisabled = false;
  public config: PerfectScrollbarConfigInterface = {};

  modalRef: BsModalRef;

  constructor(
    private menuService: MenuService,
    private modalService: BsModalService,
    private helpService: HelpService
  ) { this.loading = true ; }

  ngOnInit() {
      this.menuService
      .onGetMenu()
      .subscribe(menuItems => {
        this.menuItems = menuItems;
        this.menuItemsOptional = menuItems;
        this.menuItems.map(record => {
          record.toggle = 'open';
        });
        this.loading = false ;
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.togglePerfectScrollbar();
    });
  }

  @HostListener('window:resize', [])
  onResize() {
    this.togglePerfectScrollbar();
  }

  togglePerfectScrollbar() {
    this.isPerfectScrollbarDisabled = window.innerWidth < 1025;
  }

  toggleNavigationSub(event, item) {
    event.preventDefault();
    if (this.currentItem && this.currentItem !== item) {
      const toogle = 'toggle';
      this.currentItem[toogle] = 'close';
    }
    this.currentItem = item;
    item.toggle = (item.toggle === 'close' ? 'open' : 'close');
  }

  filterMenu(searchText: string): any[] {
    if (!this.menuItems) { return  }
    if (!this.menuItems) { return  }

    searchText = searchText.toLowerCase();
    this.menuItems = this.menuItemsOptional.filter(menu => {
      let count = 0;
       if (!(typeof(menu.submenu) === 'undefined')) {
        menu.submenu.forEach(element => {
          if(element.label.toLowerCase().includes(searchText)) {
            count = count + 1;
          }
        });
      }
      return menu.label.toLowerCase().includes(searchText) || count > 0;
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

}
